import { useListQuotesQuery, useReadQuoteQuery } from '@/store/api/commercial/quote.api';
import type { TypeApiError } from '@/types/api/types.api';
import type { TypeQuote } from '@/types/commercial/types.commercial.quote';

const EMPTY: TypeQuote[] = [];

export const useQuotes = (): TypeQuote[] => {
    const { data } = useListQuotesQuery();
    return data ?? EMPTY;
};

export const useQuotesState = () => {
    const { data, isLoading, isFetching, isError, error, refetch } = useListQuotesQuery();
    return { quotes: data ?? EMPTY, isLoading, isFetching, isError, error, refetch };
};

export const useQuoteDetail = (quoteId: string | null) => {
    const { data, isLoading, isFetching, isError, error, refetch } = useReadQuoteQuery(quoteId as string, { skip: !quoteId });
    const notFound = isError && (error as TypeApiError | undefined)?.status === 404;

    return {
        quote: data ?? null,
        isLoading,
        isFetching,
        missing: notFound,
        isError: isError && !notFound,
        refetch,
    };
};
